import axios from 'axios';
import { loginreq, req, reqblob } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("post", "/apiUser/login/login", params) };
//验证码
export const code = (uuid) => { return reqblob("get", "/apiUser/login/getCode?uuid=" + uuid) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/apiUser/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return req("post", "/apiUser/login/logout") };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/apiUser/user/getUserList", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/apiUser/user/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return req("post", "/apiUser/user/delete", params) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/apiUser/user/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return req("post", "/apiUser/user/lock", params) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/apiUser/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/apiUser/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/apiUser/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/apiUser/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/apiUser/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/apiUser/User/flashCache/" + params, {}) };
// 修改密码
export const updatePwd = (params) => { return req("post", "/apiUser/user/updatePwd", params) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/apiUser/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/apiUser/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/apiUser/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/apiUser/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/apiUser/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/apiUser/user/getRoleList", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/apiUser/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/apiUser/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/apiUser/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/apiUser/RoleRight/save", params) };


/**
 * 公司管理 
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/apiUser/company/getList", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/apiUser/company/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return req("post", "/apiUser/company/delete", params) };
//获取当前用户的公司
export const getUserCompany = (params) => { return req("post", "/apiUser/company/getUserCompany", params) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/apiUser/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/apiUser/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/apiUser/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/apiUser/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/apiUser/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/apiUser/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/apiUser/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/apiUser/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js